import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

const initialState = {
  individualDetails: [{
    id: uuid(),
    personalDetails: {
      firstName: '',
      lastName: '',
      email: '',
      middleName: '',
    },
  }],
};

const individualSlice = createSlice({
  name: 'individual',
  initialState,
  reducers: {
    addIndividual: (state, action) => {
      state.individualDetails.push(action.payload);
    },
    removeIndividual: (state, action) => {
      console.log(action, JSON.stringify(state.individualDetails));

      state.individualDetails = state.individualDetails.filter((data) => action.payload !== data.id);
    },
    resetIndividual: (state) => {
      state.individualDetails = initialState.individualDetails;
    },
    updateIndividual: (state, action) => {
      const { index, data } = action.payload;
      if (state.individualDetails[index]) {
        state.individualDetails[index] = data;
      }
    },
  },
});

export const { addIndividual, removeIndividual, updateIndividual, resetIndividual } = individualSlice.actions;
export default individualSlice.reducer;
